import { render, staticRenderFns } from "./EditorHeader.vue?vue&type=template&id=0c0aae1b"
import script from "./EditorHeader.vue?vue&type=script&lang=js"
export * from "./EditorHeader.vue?vue&type=script&lang=js"
import style0 from "./EditorHeader.vue?vue&type=style&index=0&id=0c0aae1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports